import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { BiLike } from "react-icons/bi"
import img1 from "../../../../assets/img/Services/StrategicConsulting/3.jpg";
import { FaBullseye, FaChartLine, FaMap, FaRocket, FaSync } from "react-icons/fa";
import {AiOutlineCloudServer} from "react-icons/ai"
import {FiSettings} from "react-icons/fi"

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Multi-Cloud & Hybrid Strategy
            </h1>
            <p className="text-lg text-gray-600">
            Develop a customized strategy for cloud-native solutions, hybrid-cloud integration, or multi-cloud adoption.
						 </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FiSettings className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Optimized Cloud Management</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Monitor and manage cloud resources across diverse environments.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineCloudServer className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Custom Cloud-Native Solutions
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
              Tailor cloud-native architectures to meet specific business needs.
              </p>
            </div>

          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}